import { format } from 'date-fns'
import { utcToZonedTime } from 'date-fns-tz'

export const getFormattedDate = (date: Date | string) => {
  const timezone = getTimezone()
  return format(utcToZonedTime(date, timezone), 'dd MMM, yyyy')
}

export const getUSFormattedDate = (date: Date | string) => {
  const timezone = getTimezone()
  return format(utcToZonedTime(date, timezone), 'MM/dd/yyyy')
}

export const getShortUSFormattedDate = (date: Date | string) => {
  const timezone = getTimezone()
  return format(utcToZonedTime(date, timezone), 'M/dd')
}

export const getCurrentYearAndMonth = (timezone: string = getTimezone()) => {
  const currentDate = new Date()
  const zonedDate = utcToZonedTime(currentDate, timezone)
  return format(zonedDate, 'yyyy-MM') // e.g. 2021-07
}

export const getCurrentYearAndMonthNumbers = () => {
  const today = new Date()
  const year = today.getFullYear()
  const month = today.getMonth() + 1
  const formattedMonth = month.toString().padStart(2, '0')
  return { year, month, formattedMonth }
}

export function extractYearAndMonth(dateString: string) {
  // Use the String.prototype.slice() method to extract the year and month
  const yearAndMonth = dateString.slice(0, 7)
  return yearAndMonth
}
export function formatCurrency(amount: number) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount)
}

export function formatCurrencyWithoutCents(amount: number | string) {
  if (typeof amount === 'string') {
    amount = parseFloat(amount)
  }
  amount = Math.trunc(amount)
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
  }).format(amount)
}

export function getCurrencyCents(amount: number | string): string {
  if (typeof amount === 'string') {
    amount = parseFloat(amount)
  }
  const fixed = Math.abs(amount).toFixed(2)
  return fixed.split('.')[1]
}

export function capitalizeWords(input: string): string {
  return input
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

export function formatDateForDisplay(yearAndMonth: string) {
  const [year, month] = yearAndMonth.split('-')
  const date = new Date(parseInt(year), parseInt(month) - 1)
  return date.toLocaleDateString('en-US', {
    month: 'long',
    year: 'numeric',
  })
}

export const getTimezone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone
}

export const getTodaysDateString = (): string => {
  return format(new Date(), 'yyyy-MM-dd')
}

export const formatDateString = (dateString: string): string => {
  if (!dateString) return ''

  const [year, month, day] = dateString.split('-').map(Number)
  const date = new Date(year, month - 1, day)

  return format(date, 'dd MMM, yyyy')
}

export const dateToDateString = (date: Date | string): string => {
  const dateObj = typeof date === 'string' ? new Date(date) : date
  return format(dateObj, 'yyyy-MM-dd')
}
